<template>
  <div
    class="form_item"
    :class="save_to + '_wrapper'"
    style="position: relative"
  >
    <Label :required="required" :label="label" :name="name" />
    <div class="checkbox-group">
      <div
        v-for="option in optionsList"
        :key="option.value"
        class="checkbox-item mb-2px"
      >
        <input
          type="checkbox"
          :id="option.value"
          :value="option.value"
          :name="validationLabel || label"
          v-model="selected"
          @change="handleValueChange"
          class="form-checkbox"
          v-validate="{ required }"
        />
        <label :for="option.value" class="select-none label-checkbox">{{
          option.name
        }}</label>
      </div>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span
      class="error"
      v-show="
        errors.has(validationLabel || label) &&
        ((fields[validationLabel || label].untouched &&
          !fields[validationLabel || label].dirty) ||
          (fields[validationLabel || label].touched &&
            fields[validationLabel || label].dirty))
      "
      v-text="errors.first(validationLabel || label)"
    ></span>
  </div>
</template>

<script>
// TODO replace vue-select by vue-multiselect
import { validatorComponent } from "./validatorComponentMixin";
import i18n from "./i18n";
import axios from "axios";
import { debounce } from "lodash";

export default {
  name: "multiCheckbox",
  mixins: [validatorComponent, i18n.mixin],
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
    },
    save_to: String,
    configuration: {
      type: Object,
      default() {
        return {};
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    info: String,
    validationLabel: String,
    name: String,
    ajax: Boolean,
    ajaxUrl: String,
    operationId: String,
    multiple: Boolean,
    limit: Number,
    required: Boolean,
  },
  data: function () {
    return {
      selected: [],
      isLoading: false,
      isDownloaded: false,
      ajaxOptions: [],
    };
  },
  created() {
    this.asyncFind = debounce(this.asyncFind.bind(this), 300);
  },
  computed: {
    optionsList() {
      if (this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf("http") > -1) {
        return this.ajaxOptions;
      } else {
        return this.options;
      }
    },
  },
  methods: {
    asyncFind(query) {
      if (query === "" && !this.isDownloaded) {
        this.ajaxOptions = [];
      }
      if (this.isLoading) {
        return;
      }
      if (
        this.ajax &&
        this.ajaxUrl &&
        this.ajaxUrl.includes("data-list/json/")
      ) {
        this.isLoading = true;
        axios.get(this.ajaxUrl + "?search=" + query).then((response) => {
          this.ajaxOptions = response.data;
          this.isLoading = false;
        });
        return;
      }
      if (this.isDownloaded) {
        return;
      }
      if (this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf("http") > -1) {
        this.isLoading = true;
        axios.get(this.ajaxUrl).then((response) => {
          this.ajaxOptions = response.data;
          this.isLoading = false;
          this.isDownloaded = true;
        });
      }
    },
    handleValueChange() {
      //const value = val ? val[VALUE_COL_NAME] : null;
      //this.selected = val;
      this.$emit("input", this.selected.join(":"));
    },
  },
};
</script>
<style>
.option__small {
  font-size: 0.8em;
}
.label-checkbox {
  display: inline;
  font-weight: normal;
}
.mb-2px {
  margin-bottom: 2px;
}
</style>
